export async function fetchContactCreateB2C(formData: ContactFormData) {
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client as string

  return await $fetch
    .raw('/contact/znuny', {
      baseURL: runtimeConfig.public.apiBaseURL,
      method: 'post',
      body: { ...formData, client },
    })
    .catch((error) => {
      return error.data
    })
}
